export default "__VITE_ASSET__ow$YHsGS__"